import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c072f87")

_pushScopeId("data-v-1c072f87")
const _hoisted_1 = { class: "flex align-center w-full" }
const _hoisted_2 = { class: "font-bold font-20" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode("显示统计信息")
const _hoisted_5 = { class: "margin-right-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量打标签")
const _hoisted_7 = { class: "cards flex flex-wrap" }
const _hoisted_8 = { class: "image" }
const _hoisted_9 = { class: "card-text" }
const _hoisted_10 = {
  key: 0,
  class: "card-text"
}
const _hoisted_11 = { class: "selected flex" }
const _hoisted_12 = { class: "tags" }
const _hoisted_13 = { class: "flex-center flex" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "inline-block margin-right-10" }
const _hoisted_16 = { class: "flex-center" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_card_tag_editor = _resolveComponent("card-tag-editor")
  const _component_el_drawer = _resolveComponent("el-drawer")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_collapse, { accordion: "" }, {
      default: _withId(() => [
        _createVNode(_component_el_collapse_item, null, {
          title: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, "按标签过滤: " + _toDisplayString(_ctx.filterTags.length === 0 ? '全部' : ''), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterTags, (tag) => {
                return (_openBlock(), _createBlock(_component_el_tag, {
                  key: tag.id,
                  closable: "",
                  onClose: ($event: any) => (_ctx.clickTag(tag))
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(tag.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClose"]))
              }), 128)),
              _hoisted_3,
              _createVNode("div", null, [
                _createVNode(_component_el_checkbox, {
                  type: "warning",
                  modelValue: _ctx.showTagsStatistics,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTagsStatistics = $event))
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createTextVNode(" 卡牌总计：" + _toDisplayString(_ctx.tableData.totalCount), 1)
              ])
            ])
          ]),
          default: _withId(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonCardTagCategories.filter(c => c.tags.length > 0), (category) => {
              return (_openBlock(), _createBlock("div", {
                key: category.tagCategoryId,
                class: "margin-top-10"
              }, [
                _createVNode("strong", _hoisted_5, _toDisplayString(category.tags[0].category.name) + ":", 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.tags, (tag) => {
                  return (_openBlock(), _createBlock(_component_el_badge, {
                    key: tag.id,
                    class: "margin-left-10",
                    max: "9999999",
                    value: _ctx.getCardCount(tag.id)
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_tag, {
                        onClick: ($event: any) => (_ctx.clickTag(tag)),
                        type: _ctx.isSelectedTag(tag.id) ? 'primary' : 'info'
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(tag.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "type"])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]))
            }), 128)),
            (_ctx.filterTags.length > 0)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  onClick: _ctx.showBatchTagEditor
                }, {
                  default: _withId(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.cards.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_7, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          class: "card",
          key: card
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_el_image, {
                class: "image",
                src: card.cardUrl,
                "preview-src-list": _ctx.cards.map(c => c.cardUrl)
              }, null, 8, ["src", "preview-src-list"]),
              _createVNode("div", _hoisted_9, _toDisplayString(card.cardText), 1),
              (card.author)
                ? (_openBlock(), _createBlock("div", _hoisted_10, " 作者: " + _toDisplayString(card.author.name), 1))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  onClick: ($event: any) => (_ctx.editCard(card)),
                  type: "warning",
                  size: "mini",
                  circle: "",
                  icon: "el-icon-edit"
                }, null, 8, ["onClick"]),
                _createVNode(_component_el_popconfirm, {
                  class: "block",
                  onConfirm: ($event: any) => (_ctx.removeCard(card.id)),
                  title: "确定删除吗？"
                }, {
                  reference: _withId(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "mini",
                      circle: "",
                      icon: "el-icon-close"
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(card.cardTags, (cardTag) => {
                return (_openBlock(), _createBlock(_component_el_tag, { key: cardTag }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTagName(cardTag.tagId)), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_el_pagination, {
        class: "margin-top-10",
        total: _ctx.tableData.totalCount,
        "page-count": _ctx.tableData.totalPages,
        "current-page": _ctx.tableData.pageNumber,
        onCurrentChange: _ctx.reloadPage,
        onPrevClick: _ctx.reloadPage,
        onNextClick: _ctx.reloadPage,
        background: "",
        onSizeChange: _ctx.handleSizeChange,
        "page-sizes": [10, 20, 50, 100, 200, 300, 400],
        "page-size": _ctx.currentPageSize,
        layout: "total, sizes, prev, pager, next, jumper"
      }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick", "onSizeChange", "page-size"])
    ]),
    _createVNode(_component_el_drawer, {
      title: "打标签",
      size: "40%",
      modelValue: _ctx.tagsPanelVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.tagsPanelVisible = $event)),
      direction: "rtl"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_tag_editor, {
          card: _ctx.selectedCard,
          "original-image-tags": _ctx.originalImageTags
        }, null, 8, ["card", "original-image-tags"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "批量打标签",
      size: "40%",
      modelValue: _ctx.batchTagEditorVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.batchTagEditorVisible = $event)),
      direction: "rtl"
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonCardTagCategories, (category) => {
            return (_openBlock(), _createBlock("div", {
              key: category.tagCategoryId
            }, [
              (category.tags && category.tags[0]?.category)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _createVNode("div", _hoisted_15, _toDisplayString(category.tags[0]?.category?.name) + ": ", 1),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.tags, (tag) => {
                      return (_openBlock(), _createBlock(_component_el_tag, {
                        key: tag.id,
                        onClick: ($event: any) => (_ctx.clickBatchTag(tag)),
                        type: _ctx.isSelectedBatchTag(tag.id) ? 'primary' : 'info'
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(tag.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick", "type"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode(_component_el_checkbox, {
            modelValue: _ctx.isBatchDelete,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isBatchDelete = $event)),
            label: "批量删除"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_16, [
            (!_ctx.isBatchDelete)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.batchTagConfirmed
                }, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.isBatchDelete)
              ? (_openBlock(), _createBlock(_component_el_popconfirm, {
                  key: 1,
                  onConfirm: _ctx.batchTagConfirmed,
                  title: "确定删除吗？"
                }, {
                  reference: _withId(() => [
                    _createVNode(_component_el_button, { type: "danger" }, {
                      default: _withId(() => [
                        _hoisted_18
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onConfirm"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.batchTagEditorVisible = false))
            }, {
              default: _withId(() => [
                _hoisted_19
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})